export default {
  transitions: {
    backgroundColor: 'color 0.2s ease-out, background 0.2s ease-out',
  },
  palette: {
    inlineCode: '#d6d6f5'
  },
}
